import React, {Component} from "react";
import {Button, Col, DatePicker, Divider, message, Row, Select, Spin} from "antd";
import {get, get_response, post} from 'helper/request'
import {antdSpinLoaderIcon} from "../utils/const";
import AuditLogDumpTile from "./auditlogdumptile";
import moment from "moment";
import {SyncOutlined} from "@ant-design/icons";
import "../asset/style/auditlog/downloadauditlogdump.css";
import axios from "axios";
import {AuthHeader} from "../configs/auth.token";
import {getStateAwareUrl, isCloud, isSuperuser} from "../utils/utils";
import AuditLogDeleteModal from "../component/auditlog/delete_audit_log_modal";

class AuditLogDump extends Component {

    constructor(props) {
        super(props);
        this.state = {
            user_names: [],
            selected_user_names: [],
            start_date: null,
            end_date: null,
            previous_dumps: [],
            first_time: true,
            search_usernames: [],
            is_modal_visible: false,
            form_button_disabled: false
        };
    }

    handleChange = (value) => {
        this.setState({
            selected_user_names: value,
            search_usernames: this.state.user_names
        })
    }

    downloadFileAccessLogs = (url) => {
        axios.get(getStateAwareUrl(url), {
            responseType: 'arraybuffer',
            headers: {
                'Content-Type': 'application/zip',
                'Authorization': AuthHeader()
            }
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data], {"type": "application/zip"}))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', "file_access_logs.zip")
            document.body.appendChild(link)
            link.click()
        }).catch(err => {
            message.error("Some error occurred. Not able to download");
        })

    }

    getAuditLogDumps = () => {

        const url = `/api/get_audit_logs_request/`;
        get_response(url)
            .then(response => {
                if (response.status === 200) {
                    this.setState({
                        previous_dumps: response.data
                    })
                    if (!this.state.first_time) {
                        message.success("Previous Audit Logs Dumps Refreshed.")
                    }
                    this.setState({
                        first_time: false
                    })
                }
            })
            .catch(err => {
                message.error("There is some error.")
            })
    }

    componentDidMount() {
        const url = `/api/user/?only_usernames=true`;
        get_response(url)
            .then(response => {
                if (response.status === 200) {
                    const data = response.data;
                    const usernames = [];
                    data.forEach(userData => {
                        usernames.push(userData.username);
                    })
                    this.setState({
                        user_names: usernames,
                        search_usernames: usernames
                    })
                }
            })
            .catch(err => {
                message.error("There is some error.")
            })

        this.getAuditLogDumps()


    }


    submitForm = async () => {

        this.setState({
            form_button_disabled: true
        })
        const url = "/api/create_audit_logs/"
        if (this.state.start_date === null) {
            message.error("Please Select Start Date.")
            this.setState({
                form_button_disabled: false
            })
            return
        }
        if (this.state.end_date === null) {
            message.error("Please Select End Date.")
            this.setState({
                form_button_disabled: false
            })
            return
        }
        if (this.state.end_date < this.state.start_date) {
            message.error("End Date cannot be before Start Date.")
            this.setState({
                form_button_disabled: false
            })
            return
        }
        let data = {
            user_names: this.state.selected_user_names,
            start_date: this.state.start_date,
            end_date: this.state.end_date,
            all_users: false
        }


        if (this.state.selected_user_names.length === 0) {
            data.user_names = this.state.user_names;
            data.all_users = true
        }

        return post(url, data).then((response) => {
            let tileData = {
                id: Math.floor(Math.random() * 1000),
                data: data,
                created_at: new Date().toISOString(),
                status: "PENDING",
            }
            this.setState({
                previous_dumps: [tileData, ...this.state.previous_dumps],
                form_button_disabled: false
            })
            message.success("Creating Audit Log. Come back after some time to download.")
        }).catch(err => {
            this.setState({
                form_button_disabled: false
            })
            message.error("Some error occurred. Not able to download");
        })
    }

    downloadAccessLogs(access_type) {
        const url = `/api/get_access_log_file/?access_type=${access_type}`
        if (access_type === "user_file_access_logs") {
            this.downloadFileAccessLogs(url)
            return
        }
        get(url).then((response) => {
            message.success("File Downloaded Successfully")
            const url = window.URL.createObjectURL(new Blob([response]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', access_type + ".log")
            document.body.appendChild(link)
            link.click()
            link.remove()
        }).catch(err => {
            message.error("Some error occurred. Not able to download");
        })
    }

    filterStringsByPrefix = (strings, prefix) => {
        return strings.filter(str => str.includes(prefix));
    }
    typeAheadSearch = (value) => {
        if (value.length > 0) {
            this.setState({
                search_usernames: this.filterStringsByPrefix(this.state.user_names, value)
            })
        }
        if (value.length === 0) {
            this.setState({
                search_usernames: this.state.user_names
            })
        }
    }
    closeModal = () => {
        this.setState({
            is_modal_visible: false
        })
    }

    openModal = () => {
        this.setState({
            is_modal_visible: true
        })
    }

    render() {
        const usersPresent = this.state.search_usernames.length;
        let usernameSuggestionsBox = usersPresent > 0 ?

            <Select.OptGroup label={<div><b>{usersPresent}</b> result{usersPresent > 1 ? 's' : ''} found </div>}>
                {this.state.search_usernames.map((item, index) => (
                    <Select.Option
                        key={index}
                        value={item}
                        label={item}
                        className='search-result-tag'
                        size='small'
                        type='tag'
                    >
                        {item} <span style={{float: "right", fontSize: 12}}></span>
                    </Select.Option>
                ))}
            </Select.OptGroup> : undefined;


        return (
            <Spin spinning={this.state.user_names.length === 0} indicator={antdSpinLoaderIcon}>
                <AuditLogDeleteModal showModal={this.state.is_modal_visible} closeModal={this.closeModal}
                                     refreshDump={this.getAuditLogDumps}/>
                <Row className={"full-parent"} style={{backgroundColor: "white"}}>
                    <Col
                        style={{backgroundColor: 'white', padding: 20, height: "100%"}} xl={16} xs={24}>
                        <div>
                            <div style={{fontSize: 20, fontWeight: 400}}>
                                Download Audit Log Data
                            </div>
                            <Divider color={"#000"} style={{opacity: '1', margin: 20}}/>

                            <Row style={{marginTop: "20px"}}>
                                <Col xl={10} xs={24}>
                                    <Row style={{height: "25px"}}>
                                        Select Start Date
                                    </Row>
                                    <Row>

                                        <DatePicker
                                            format="YYYY-MM-DD"
                                            onChange={(date, dateString) => {
                                                if (dateString !== null && dateString.length !== 0)
                                                    this.setState({
                                                        start_date: dateString
                                                    })
                                                else
                                                    this.setState({
                                                        start_date: null
                                                    })
                                            }}
                                            disabledDate={(current) => {
                                                return moment() < current
                                            }}
                                        />
                                    </Row>
                                    <Row span={23} offset={1}>
                                        <div style={{fontSize: 11}}>The date from which you want audit log.</div>
                                    </Row>


                                </Col>
                                <Col xl={10} xs={24}>
                                    <Row style={{height: "25px"}}>
                                        Select End Date
                                    </Row>
                                    <Row>
                                        <DatePicker
                                            format="YYYY-MM-DD"
                                            req
                                            onChange={(date, dateString) => {
                                                if (dateString !== null && dateString.length !== 0)
                                                    this.setState({
                                                        end_date: dateString
                                                    })
                                                else
                                                    this.setState({
                                                        end_date: null
                                                    })
                                            }}
                                            disabledDate={(current) => {
                                                return moment() < current
                                            }}
                                        />
                                    </Row>
                                    <Row span={23}>
                                        <div style={{fontSize: 11}}>The date till which you want audit log.</div>
                                    </Row>

                                </Col>

                            </Row>
                            <Row style={{marginTop: "20px"}}>
                                <Row span={12}>
                                    Select Users
                                </Row>
                                <Row span={12}>
                                    <Select
                                        showSearch
                                        id="search-bar"
                                        placeholder="Select Users"
                                        showArrow={false}
                                        filterOption={false}
                                        notFoundContent={null}
                                        onSearch={this.typeAheadSearch}
                                        mode="multiple"
                                        onChange={this.handleChange}
                                        optionLabelProp="label"
                                        value={this.state.selected_user_names}
                                        style={{
                                            overflowY: "auto",
                                            width: "80%",
                                            marginBottom: "0px !important",
                                            height: "32px"
                                        }}
                                    >
                                        {usernameSuggestionsBox}
                                    </Select>
                                </Row>
                                <Row span={23} style={{marginTop: "-6px"}}>
                                    <div style={{fontSize: 11}}>Allows the selection of specific users for audit log
                                        retrieval, <b> if left empty, all users will be selected </b> for audit log
                                        retrieval.
                                    </div>
                                </Row>
                            </Row>
                            <Row>
                                <Col style={{marginTop: "20px"}} xl={6} xs={24}>
                                    <Button type="primary" ghost onClick={this.submitForm}
                                            disabled={this.state.form_button_disabled}>
                                        Generate Audit Log
                                    </Button>
                                </Col>
                                {isSuperuser() && !isCloud() &&
                                    <Button type="danger" ghost
                                            style={{marginTop: "20px", float: "right"}}
                                            onClick={() => this.openModal()}
                                    >
                                        Delete All Audit Logs
                                    </Button>}

                            </Row>


                            {this.state.previous_dumps.length !== 0 && <div>
                                <Row>
                                    <div style={{
                                        fontSize: 20,
                                        fontWeight: 400,
                                        marginTop: "20px",
                                        marginBottom: "10px"
                                    }}>
                                        Previous Audit Logs Dump
                                        <Button style={{float: "right"}} onClick={this.getAuditLogDumps}>
                                            <SyncOutlined/>
                                        </Button>
                                    </div>
                                </Row>
                                <Divider color={"#000"} style={{opacity: '1', margin: "20px"}}/>

                            </div>}
                        </div>

                        <Row style={{
                            width: "100%",
                            overflowY: "auto",
                            display: "flex",
                            flexWrap: "wrap",
                        }} className={"dynamic-container"}>

                            {this.state.previous_dumps.length !== 0 && this.state.previous_dumps.map(data => (
                                <AuditLogDumpTile id={data.id} data={data.data} created_at={data.created_at}
                                                  status={data.status}/>))}
                        </Row>
                    </Col>
                    {!isCloud() && <Col xl={8} xs={24} style={{backgroundColor: 'white', padding: 20}}>
                        <div style={{fontSize: 20, fontWeight: 400}}>
                            Access Other Logs
                        </div>
                        <Divider color={"#000"} style={{opacity: '1', margin: 20}}/>

                        <Row>
                            <div style={{margin: "20px 20px 20px 0px", fontSize: "16px"}}>Operating systems Login Logs
                                <Button type="primary" ghost shape="round" icon="download" size="16px"
                                        style={{float: "right"}}
                                        onClick={() => {
                                            this.downloadAccessLogs("os_login_logs")
                                        }}/></div>
                            <div className={"description"}>Linux's login logs document user authentication and system
                                access, serving as crucial
                                data for security monitoring, providing insights into login events for
                                comprehensive system analysis.
                            </div>
                        </Row>

                        <Row>
                            <div style={{margin: "20px 20px 20px 0px", fontSize: "16px"}}>File Access Logs
                                <Button type="primary" ghost shape="round" icon="download" size="16px"
                                        style={{float: "right"}}
                                        onClick={() => {
                                            this.downloadAccessLogs("user_file_access_logs")
                                        }}/></div>
                            <div className={"description"}>User file access logs provide a detailed record of
                                user-specific file requests made to the web server. These logs typically include the
                                user's IP address, requested file paths, timestamps, and other relevant details.
                            </div>
                        </Row>

                        <Row>
                            <div style={{margin: "20px 20px 20px 0px", fontSize: "16px"}}>Firewall Logs
                                <Button type="primary" ghost shape="round" icon="download" size="16px"
                                        style={{float: "right"}}
                                        onClick={() => {
                                            this.downloadAccessLogs("firewall_logs")
                                        }}/></div>
                            <div className={"description"}>Firewall logs provide a record of activities related to
                                network traffic and firewall rules. These logs are crucial for monitoring and analyzing
                                security events on a system.
                            </div>
                        </Row>
                    </Col>}

                </Row>
            </Spin>
        );
    }


}

export default AuditLogDump;